// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MdrDsqGpfHTpg6RPjzZ8 {
    width: 30rem !important;
    min-width: 30rem !important;
}`, "",{"version":3,"sources":["webpack://./pages/Membership/MembershipDetails/style.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B","sourcesContent":[".datePicker {\n    width: 30rem !important;\n    min-width: 30rem !important;\n}"],"sourceRoot":""}]);
// Exports
export var datePicker = `MdrDsqGpfHTpg6RPjzZ8`;
export default ___CSS_LOADER_EXPORT___;
